const musicLibrary = [
    {
        title: 'Let it happen',
        artist: 'Tame Impala',
        genre: 'rock',
        rating: 5,
        url: 'https://images-na.ssl-images-amazon.com/images/I/91sqAJFwmJL._SX522_.jpg',
        id: 1,
    },
    {
        title: 'Famous',
        artist: 'Kanye West',
        genre: 'rap',
        rating: 2,
        url: 'https://i.pinimg.com/originals/fe/54/7c/fe547c2c301778a58f7c3eb1afb1f2d6.jpg',
        id: 2,
    },
    {
        title: 'Glitter',
        artist: '070 Shake',
        genre: 'rap',
        rating: 2,
        url: 'https://m.media-amazon.com/images/I/81DFpJo8RAL._AC_UL640_FMwebp_QL65_.jpg',
        id: 3,
    },
    {
        title: 'Tout oublier',
        artist: 'Angele',
        genre: 'lofi',
        rating: 5,
        url: 'https://m.media-amazon.com/images/I/71SSPaOtv0L._SS500_.jpg',
        id: 4,
    },
    {
        title: 'Do i want to know',
        artist: 'Arctic Monkeys',
        genre: 'rock',
        rating: 5,
        url: 'https://images-na.ssl-images-amazon.com/images/I/71-Y-3usHkL._SX522_.jpg',
        id: 5,
    },
    {
        title: 'Dangerous Woman',
        artist: 'Ariana Grande',
        genre: 'pop',
        rating: 1,
        url: 'https://images-na.ssl-images-amazon.com/images/I/A1A-okb0pnL._SX522_.jpg',
        id: 6,
    },
    {
        title: 'Stayin Alive',
        artist: 'The Bee Gees',
        genre: 'soul',
        rating: 5,
        url: 'https://m.media-amazon.com/images/I/71nHBwMAfPL._SS500_.jpg',
        id: 7,
    },
    {
        title: 'The Morning',
        artist: 'Kanye West',
        genre: 'rap',
        rating: 4,
        url: 'https://m.media-amazon.com/images/I/91t+eCGM2dL._SS500_.jpg',
        id: 8,
    },
    {
        title: 'Good Morning',
        artist: 'Kanye West',
        genre: 'rap',
        rating: 2,
        url: 'https://images-na.ssl-images-amazon.com/images/I/517xpFR6h0L.jpg',
        id: 9,
    },
    {
        title: 'Feather',
        artist: 'Nujabes',
        genre: 'lofi',
        rating: 4,
        url: 'https://images-na.ssl-images-amazon.com/images/I/517P-GpjORL.jpg',
        id: 10,
    },
    {
        title: 'Green Light',
        artist: 'Lorde',
        genre: 'pop',
        rating: 3,
        url: 'https://images-na.ssl-images-amazon.com/images/I/A18QUHExFgL._SX522_.jpg',
        id: 11,
    },
    {
        title: 'Mothercreep',
        artist: 'FKA Twigs',
        genre: 'rnb',
        rating: 5,
        url: 'https://images-na.ssl-images-amazon.com/images/I/71AAHY5B-VL._SX522_.jpg',
        id: 12,
    },
    {
        title: 'Honey Baby',
        artist: 'Kali Uchis',
        genre: 'latin',
        rating: 4,
        url: 'https://m.media-amazon.com/images/I/81gF6Ng4XKL._SS500_.jpg',
        id: 13,
    },
    {
        title: 'Midnight City',
        artist: 'M83',
        genre: 'pop',
        rating: 2,
        url: 'https://images-na.ssl-images-amazon.com/images/I/81tEvdYVSPL._SX522_.jpg',
        id: 14,
    },
    {
        title: 'We',
        artist: 'Mac Miller',
        genre: 'rap',
        rating: 5,
        url: 'https://images-na.ssl-images-amazon.com/images/I/71Dognt3-pL._SX522_.jpg',
        id: 15,
    },
    {
        title: 'Redbone',
        artist: 'Childish Gambino',
        genre: 'soul',
        rating: 3,
        url: 'https://images-na.ssl-images-amazon.com/images/I/717kcsRRb7L._SX522_.jpg',
        id: 16,
    },
    {
        title: 'Loft Music',
        artist: 'The Weeknd',
        genre: 'rnb',
        rating: 2,
        url: 'https://images-na.ssl-images-amazon.com/images/I/71K19rihxhL._SX522_.jpg',
        id: 17,
    },
    {
        title: 'X',
        artist: 'The XX',
        genre: 'lofi',
        rating: 5,
        url: 'https://images-na.ssl-images-amazon.com/images/I/71BDlZXYt5L._SX522_.jpg',
        id: 18,
    },
    {
        title: 'One More Time',
        artist: 'Daft Punk',
        genre: 'jazz',
        rating: 3,
        url: 'https://images-na.ssl-images-amazon.com/images/I/61Ia07wdZQL._SX522_.jpg',
        id: 19,
    },
    {
        title: 'Is it true',
        artist: 'Tame Impala',
        genre: 'rock',
        rating: 3,
        url: 'https://m.media-amazon.com/images/I/71B-s-1n5iL._SS500_.jpg',
        id: 20,
    },
];

export default musicLibrary;